export default __webpack_public_path__ + "static/media/740.f986bcf3.png";